/* eslint-disable no-unused-vars */

'use strict';

var isCart = $('[data-action="Cart-Show"]').length > 0;

// ID Selectors
const bopisMethodID = '#bopis-method';

// Class Selectors
const mapCanvasClass = '.map-canvas';
const storeLocatorNoResultsClass = '.store-locator-no-results';
const selectStoreClass = '.select-store';

// Variables
const searchKey = 'search-key';

/** copy/override of file from base
 * doing entire file because not everything was overridable from module exports
*/

// array to store all map markers as they are created
let markers = [];
const google = window.google;

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    let newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Updates the bopis store per line item on the cart
 * @param {string} url - route to update the store
 * @param {Object} data - object containing current line item data
 */
function updateStoreForLineItem(url, data) {
    $.spinner().start();
    $.ajax({
        url: appendToUrl(url, {
            storeId: data.storeID,
            shipmentId: data.currentShipmentUUID,
            productLineItemId: data.currentLineItemUUID
        }),
        type: 'get',
        dataType: 'json',
        success: function (res) {
            $('#inStoreInventoryModal').modal('hide');
            $('#inStoreInventoryModal').remove();

            // Update line item on cart
            if (isCart) {
                $('.product-info.uuid-' + data.currentLineItemUUID).replaceWith(res.updatedProductCard);
                $.spinner().stop();
            } else {
                // TODO...for now, the safest option is to just trigger a page reload if the user changes store on a line item within checkout, otherwise we'll need to figure out exactly what parts of the DOM / form we need to update with the updated shipment information
                window.location.reload();
            }
        }
    });
}

/**
 * Uses google maps api to render a map
 */
function maps() {
    var map;
    var infowindow = new google.maps.InfoWindow();
    markers = [];

    // Init U.S. Map in the center of the viewport as default
    var latNum = 37.09024;
    var lngNum = -95.712891;

    // set default zoom to 4
    var zoomLevel = 4;

    // check if there is a country code and try to center the map using that
    // lat and long coordinates pulled from google maps
    var storeCountry = $(mapCanvasClass).attr('data-store-country');
    switch (storeCountry) {
        case 'AU':
            latNum = -25.2744;
            lngNum = 133.7751;
            break;
        case ' CA':
            latNum = 56.1304;
            lngNum = -106.3468;
            break;
        case 'EU':
            latNum = 54.5260;
            lngNum = 15.2551;
            break;
        case 'NZ':
            latNum = -40.9006;
            lngNum = 174.8860;
            zoomLevel = 5;
            break;
        default:
            break;
    }

    var latlng = new google.maps.LatLng(latNum, lngNum);

    var mapOptions = {
        scrollwheel: false,
        zoom: zoomLevel,
        center: latlng
    };

    map = new google.maps.Map($(mapCanvasClass)[0], mapOptions);
    var mapdiv = $(mapCanvasClass).attr('data-locations');

    mapdiv = JSON.parse(mapdiv);

    var bounds = new google.maps.LatLngBounds();

    // Customized google map marker icon with svg format
    var markerImg = {
        path: 'M13.5,30.1460153 L16.8554555,25.5 L20.0024287,25.5 C23.039087,25.5 25.5,'
            + '23.0388955 25.5,20.0024287 L25.5,5.99757128 C25.5,2.96091298 23.0388955,0.5 '
            + '20.0024287,0.5 L5.99757128,0.5 C2.96091298,0.5 0.5,2.96110446 0.5,5.99757128 '
            + 'L0.5,20.0024287 C0.5,23.039087 2.96110446,25.5 5.99757128,25.5 L10.1445445,'
            + '25.5 L13.5,30.1460153 Z',
        fillColor: '#cf0a2c',
        fillOpacity: 1,
        scale: 1.1,
        strokeColor: 'white',
        strokeWeight: 1,
        anchor: new google.maps.Point(13, 30),
        labelOrigin: new google.maps.Point(12, 12)
    };

    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var label = parseInt(key, 10) + 1;
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            icon: markerImg,
            label: { text: label.toString(), color: 'white', fontSize: '16px' }
        });

        marker.addListener('click', function () {
            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.open(map, marker);
            // update the display list selected option
            var storeID = item.storeId;
            $('#' + storeID + ' input').get(0).click();
        });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);

        // push to the global markers array
        markers.push(marker);
    });
    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $(mapCanvasClass);
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $(storeLocatorNoResultsClass).show();
    } else {
        $(storeLocatorNoResultsClass).hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data(searchKey, data.searchKey);

    $resultsDiv.attr('data-has-results', hasResults);
    $resultsDiv.attr('data-radius', data.radius);
    $resultsDiv.attr('data-search-key', JSON.stringify(data.searchKey));

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');
    var radius = $('.results').data('radius');
    var url = $form.attr('action');
    var urlParams = { radius: radius };

    var requestedPostalCode = $form.find('[name="postalCode"]').val();

    // Save requested Postal Code and update DOM elements with new data
    if (window.sitePrefs.bopisEnabled) {
        document.cookie = 'requestedPostalCode=' + requestedPostalCode + '; path=/';
        $('.change-store').each(function () {
            $(this).data('postal', requestedPostalCode);
        });
    }

    var payload = $form.is('form') ? $form.serialize() : { postalCode: requestedPostalCode };

    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $(selectStoreClass).prop('disabled', true);
        }
    });
    return false;
}

module.exports = {
    init: function () {
        if ($(mapCanvasClass).data('has-google-api')) {
            maps();
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if (!$('.results').data('has-results')) {
            $(storeLocatorNoResultsClass).show();
        }
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition(function (position) {
                var $detectLocationButton = $('.detect-location');
                var url = $detectLocationButton.data('action');
                var radius = $('.results').data('radius');
                var urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };

                url = appendToUrl(url, urlParams);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        updateStoresResults(data);
                        $(selectStoreClass).prop('disabled', true);
                    }
                });
            });
        });
    },

    search: function () {
        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
            search($(this));
        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
            search($(this));
        });
    },

    changeRadius: function () {
        $('.store-locator-container .radius').change(function () {
            var radius = $(this).val();
            var searchKeys = $('.results').data(searchKey);
            var currentPostalCode = $('#store-postal-code[name="postalCode"]').val();
            var url = $(this).data('action-url');
            var urlParams = {};

            urlParams = {
                radius: radius,
                postalCode: currentPostalCode,
                lat: searchKeys.lat,
                long: searchKeys.long
            };

            url = appendToUrl(url, urlParams);
            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    spinner.stop();
                    updateStoresResults(data);
                    $(selectStoreClass).prop('disabled', true);
                }
            });
        });
    },
    selectStore: function () {
        $('.store-locator-container').on('click', selectStoreClass, (function (e) {
            e.preventDefault();
            var isLineItemStoreSelection = $(this).hasClass('update-line-item-store');
            var modal = $(this).parents('.select-store-modal');
            var currentLineItemUUID = isLineItemStoreSelection ? modal.data('currentUuid') : null;
            var currentShipmentUUID = isLineItemStoreSelection ? modal.data('currentShipmentUuid') : null;
            var selectedStore = $(':checked', '.results-card .results');

            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data(searchKey).postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                currentLineItemUUID: currentLineItemUUID,
                currentShipmentUUID: currentShipmentUUID,
                event: e
            };

            if (!isLineItemStoreSelection) {
                $('body').trigger('store:selected', data);
            } else {
                updateStoreForLineItem($(this).data('action-url'), data);
            }
        }));
    },

    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', (function () {
            $(selectStoreClass).prop('disabled', false);
        }));
    },

    updateSelectedStoreView: function () {
        $('body').on('change', '.select-store-input', (function () {
            $(selectStoreClass).prop('disabled', false);

            if ($(mapCanvasClass).length >= 1) {
                // if the google map is present, open or update the store modal on map
                var storeIndex = $('.results.striped div.px-2.py-3').index($(this).closest($('.px-2.py-3')));
                google.maps.event.trigger(markers[storeIndex], 'click');
            } else {
                // no google map so move on

            }
        }));
    }
};
